export const DataLocationSection = () => (
  <section>
    <h2>3. Data Location</h2>

    <p>
      We and our authorized Service Providers (defined below) maintain, store
      and process Personal Data in the United States of America and other
      locations, as reasonably necessary for the proper performance and delivery
      of our Services, or as may be required by law; provided that Customer Data
      may only be processed in such locations as permitted in our Data
      Processing Addendum and other commercial agreements with such customer.
    </p>

    <p>
      While privacy laws may vary between jurisdictions, Volca and its
      affiliates and Service Providers are each committed to protect Personal
      Data in accordance with this Privacy Policy and customary industry
      standards, regardless of any lesser legal requirements that may apply in
      their jurisdiction. Among others, we have ensured that all transfers of
      Personal Data which originate from the EEA and made at our direction or
      control are based on appropriate data transfer mechanisms as established
      under the GDPR.
    </p>
  </section>
);
